var _clipPath, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuittingajobRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)",
    style: {
      fill: "#4079FF"
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-63"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.92a5.71,5.71,0,0,1-5.71-5.71V60.66A5.71,5.71,0,0,1,43.92,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.92,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,55H260.21a5.72,5.72,0,0,0-5.71,5.71V332.09a5.72,5.72,0,0,0,5.71,5.71h193.1a5.71,5.71,0,0,0,5.71-5.71V60.66A5.71,5.71,0,0,0,453.31,55Zm5.46,277.14a5.47,5.47,0,0,1-5.46,5.46H260.21a5.47,5.47,0,0,1-5.46-5.46V60.66a5.47,5.47,0,0,1,5.46-5.46h193.1a5.47,5.47,0,0,1,5.46,5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.91,
    y: 73.1,
    width: 74.97,
    height: 254.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.72 73.1 119.34 73.1 93.19 327.43 97.57 327.43 123.72 73.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 69.88,
    width: 76.23,
    height: 3.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.43,
    y: 327.21,
    width: 76.23,
    height: 4.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.62,337.16H56V63.58h82.64Zm-76.34-6.3h70v-261h-70Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.63,
    y: 73.1,
    width: 74.97,
    height: 254.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.81 73.1 180.91 73.1 154.76 327.43 178.66 327.43 204.81 73.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.15,
    y: 69.88,
    width: 76.23,
    height: 3.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.15,
    y: 327.21,
    width: 76.23,
    height: 4.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.35,337.16H146.7V63.58h82.65ZM153,330.86h70.05v-261H153Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.36,
    y: 73.1,
    width: 74.97,
    height: 254.33,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.64 73.1 278.26 73.1 252.11 327.43 256.5 327.43 282.64 73.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.88,
    y: 69.88,
    width: 76.23,
    height: 3.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.88,
    y: 327.21,
    width: 76.23,
    height: 4.45,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.07,337.16H237.43V63.58h82.64Zm-76.34-6.3h70v-261h-70Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.84,
    y: 125.05,
    width: 70.7,
    height: 81.95,
    transform: "translate(219.13 552.34) rotate(-89.7)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.44,
    y: 117.45,
    width: 81.95,
    height: 13.23,
    transform: "translate(774.16 250.16) rotate(-179.7)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.64 199.17 425.59 199.6 428.35 130.89 346.4 130.46 343.64 199.17",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.63 147.44 405.19 147.66 405.68 135.56 365.11 135.35 364.63 147.44",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "411.39 163.31 422.23 163.37 422.66 152.53 411.83 152.48 411.39 163.31",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "396.02 163.23 406.86 163.29 407.29 152.45 396.46 152.4 396.02 163.23",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.81 177.92 421.64 177.98 422.07 167.15 411.24 167.09 410.81 177.92",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "410.22 192.53 421.05 192.59 421.49 181.76 410.65 181.7 410.22 192.53",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.44 177.84 406.27 177.9 406.71 167.06 395.87 167.01 395.44 177.84",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.07 177.76 390.9 177.82 391.34 166.98 380.5 166.93 380.07 177.76",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.7 177.68 375.53 177.74 375.97 166.9 365.13 166.85 364.7 177.68",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.33 177.6 360.16 177.66 360.6 166.82 349.76 166.77 349.33 177.6",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.85 192.45 405.68 192.51 406.12 181.68 395.28 181.62 394.85 192.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.48 192.37 390.31 192.43 390.75 181.59 379.91 181.54 379.48 192.37",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.11 192.29 374.94 192.35 375.38 181.51 364.54 181.46 364.11 192.29",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.65 163.15 391.49 163.21 391.92 152.37 381.09 152.32 380.65 163.15",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.65 163.15 391.49 163.21 391.92 152.37 381.09 152.32 380.65 163.15",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.28 163.07 376.12 163.12 376.55 152.29 365.72 152.24 365.28 163.07",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "365.28 163.07 376.12 163.12 376.55 152.29 365.72 152.24 365.28 163.07",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.91 162.99 360.75 163.04 361.18 152.21 350.35 152.15 349.91 162.99",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.91 162.99 360.75 163.04 361.18 152.21 350.35 152.15 349.91 162.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.74 192.21 359.57 192.27 360.01 181.43 349.18 181.38 348.74 192.21",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.19,113.84a4.74,4.74,0,1,0,4.73,4.74A4.74,4.74,0,0,0,387.19,113.84Zm0,8.33a3.6,3.6,0,1,1,3.59-3.59A3.59,3.59,0,0,1,387.19,122.17Z",
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-63"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-63",
    cx: 245.18,
    cy: 412.39,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M316.36,321.5h58.31s-13.12,3-22.47,4.28v5.32H338.83v-5.32C329.48,324.46,316.36,321.5,316.36,321.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.35,307.82H365.09a72.63,72.63,0,0,0,0-23.54h11.26A73.2,73.2,0,0,1,376.35,307.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.86,
    y: 331.1,
    width: 17.31,
    height: 39.38,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.86,
    y: 331.1,
    width: 17.31,
    height: 39.38,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.12,287h-48.5a8.85,8.85,0,0,1-8.81-10.51,427.23,427.23,0,0,0,3.72-52.41,8.78,8.78,0,0,1,8.92-9.08h40.84a11,11,0,0,1,10.65,9.08,427.5,427.5,0,0,1,3.95,52.41A10.9,10.9,0,0,1,395.12,287Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.28,276.46a425.54,425.54,0,0,0-3.95-52.41A11,11,0,0,0,382.68,215H350.45a8.78,8.78,0,0,0-8.92,9.08,427.23,427.23,0,0,1-3.72,52.41A8.85,8.85,0,0,0,346.62,287h39.9A10.89,10.89,0,0,0,397.28,276.46Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.28,276.46a425.54,425.54,0,0,0-3.95-52.41A11,11,0,0,0,382.68,215H350.45a8.78,8.78,0,0,0-8.92,9.08,427.23,427.23,0,0,1-3.72,52.41A8.85,8.85,0,0,0,346.62,287h39.9A10.89,10.89,0,0,0,397.28,276.46Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.67,376a1.44,1.44,0,0,1-1.75,1.41c-5.31-1.15-21.2-4.5-27.4-4.5s-22.1,3.35-27.41,4.5a1.44,1.44,0,0,1-1.75-1.41h0a3.79,3.79,0,0,1,3-3.71c6.21-1.34,20.38-4.24,26.16-4.24s19.94,2.9,26.15,4.24a3.79,3.79,0,0,1,3,3.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.36,373.06a5,5,0,1,0,5,5A5,5,0,0,0,316.36,373.06Zm0,7.69a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,316.36,380.75Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.52,373.06a5,5,0,1,0,5,5A5,5,0,0,0,345.52,373.06Zm0,7.69a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,345.52,380.75Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.07,373.06a5,5,0,1,0,5,5A5,5,0,0,0,374.07,373.06Zm0,7.69a2.7,2.7,0,1,1,2.7-2.7A2.7,2.7,0,0,1,374.07,380.75Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,307.07A396.11,396.11,0,0,1,302,305a6.29,6.29,0,0,0-7.19,6.38v1a8.28,8.28,0,0,0,7.19,8,398.89,398.89,0,0,0,58.24,2.05Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.28,307.07A396.11,396.11,0,0,1,302,305a6.29,6.29,0,0,0-7.19,6.38v1a8.28,8.28,0,0,0,7.19,8,398.89,398.89,0,0,0,58.24,2.05Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.37,320.36c-11.12,1-22.09,1.77-33.25,2.22a6.68,6.68,0,0,1-6.85-6.72v-1.7a7,7,0,0,1,6.85-7c11.16-.44,22.13-1.18,33.25-2.22a6,6,0,0,1,6.81,6v1.7A7.85,7.85,0,0,1,389.37,320.36Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.96 396.33 416.72 396.33 415.85 275.72 419.96 275.72 419.96 396.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "419.96 396.33 416.72 396.33 415.85 275.72 419.96 275.72 419.96 396.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.2 396.33 419.96 396.33 419.96 275.72 424.07 275.72 423.2 396.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "423.2 396.33 419.96 396.33 419.96 275.72 424.07 275.72 423.2 396.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.53 396.33 227.29 396.33 226.42 275.72 230.53 275.72 230.53 396.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "230.53 396.33 227.29 396.33 226.42 275.72 230.53 275.72 230.53 396.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.76 396.33 230.53 396.33 230.53 275.72 234.64 275.72 233.76 396.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.76 396.33 230.53 396.33 230.53 275.72 234.64 275.72 233.76 396.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 267.84,
    width: 190.73,
    height: 7.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.45,
    y: 267.84,
    width: 190.73,
    height: 7.87,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.87,
    y: 267.84,
    width: 49.71,
    height: 7.87,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 380.87,
    y: 267.84,
    width: 49.71,
    height: 7.87,
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.82,
    y: 275.72,
    width: 189.43,
    height: 12.98,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-63)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)",
    style: {
      fill: "#4079FF",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-63)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 394.26,
    y: 275.72,
    width: 25.7,
    height: 12.98,
    transform: "translate(814.22 564.42) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "204.82 404.33 201.59 404.33 200.71 275.72 204.82 275.72 204.82 404.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "204.82 404.33 201.59 404.33 200.71 275.72 204.82 275.72 204.82 404.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.06 404.33 204.82 404.33 204.82 275.72 208.93 275.72 208.06 404.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.06 404.33 204.82 404.33 204.82 275.72 208.93 275.72 208.06 404.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.26 404.33 391.02 404.33 390.15 275.72 394.26 275.72 394.26 404.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.26 404.33 391.02 404.33 390.15 275.72 394.26 275.72 394.26 404.33",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.49 404.33 394.26 404.33 394.26 275.72 398.37 275.72 397.49 404.33",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.49 404.33 394.26 404.33 394.26 275.72 398.37 275.72 397.49 404.33",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.53,186.34h-5.75L324,247h5.74a1.58,1.58,0,0,0,1.6-1.72l-4-57.22A1.88,1.88,0,0,0,325.53,186.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.53,186.34h-5.75L324,247h5.74a1.58,1.58,0,0,0,1.6-1.72l-4-57.22A1.88,1.88,0,0,0,325.53,186.34Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.47,247H240.4a1.88,1.88,0,0,1-1.85-1.72l-4-57.22a1.58,1.58,0,0,1,1.6-1.72h86.08a1.87,1.87,0,0,1,1.84,1.72l4,57.22A1.59,1.59,0,0,1,326.47,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.47,247H240.4a1.88,1.88,0,0,1-1.85-1.72l-4-57.22a1.58,1.58,0,0,1,1.6-1.72h86.08a1.87,1.87,0,0,1,1.84,1.72l4,57.22A1.59,1.59,0,0,1,326.47,247Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.31,232.34c-12.73.3-40.91,14.66-40.91,14.66h86.07S294.91,232,281.31,232.34Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,235.72a2.25,2.25,0,0,0-2.25-2.14H274.82a2.24,2.24,0,0,0-2.25,2.14L271,267.84h23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.48,235.72a2.25,2.25,0,0,0-2.25-2.14H274.82a2.24,2.24,0,0,0-2.25,2.14L271,267.84h23Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.22,235.72a2.25,2.25,0,0,0-2.25-2.14h-1.74a2.25,2.25,0,0,1,2.25,2.14L294,267.84h1.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.82,270.5h-2.47a.48.48,0,0,1-.48-.47v-2.62a.48.48,0,0,1,.48-.47h1.77a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,304.82,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.24,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.77a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,308.24,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47H311a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,311.66,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,315.08,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,270.5H316a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,318.5,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.92,270.5h-2.47A.47.47,0,0,1,319,270v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,321.92,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.34,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,325.34,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,328.76,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,332.18,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,335.6,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,339,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,270.5H340a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,342.44,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.87,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,345.87,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,349.29,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.71,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47H352a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,352.71,270.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M304.82,270.5h-2.47a.48.48,0,0,1-.48-.47v-2.62a.48.48,0,0,1,.48-.47h1.77a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,304.82,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.24,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.77a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,308.24,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.66,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47H311a.47.47,0,0,1,.46.35l.7,2.62A.47.47,0,0,1,311.66,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.08,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,315.08,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,270.5H316a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,318.5,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.92,270.5h-2.47A.47.47,0,0,1,319,270v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,321.92,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.34,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,325.34,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.76,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,328.76,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.18,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,332.18,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,335.6,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,270.5h-2.47a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,339,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.44,270.5H340a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,342.44,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.87,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,345.87,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.29,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47h1.78a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,349.29,270.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.71,270.5h-2.48a.47.47,0,0,1-.47-.47v-2.62a.47.47,0,0,1,.47-.47H352a.47.47,0,0,1,.45.35l.7,2.62A.47.47,0,0,1,352.71,270.5Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 299.86,
    y: 268.72,
    width: 55.34,
    height: 4.12,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.86,
    y: 268.72,
    width: 55.34,
    height: 4.12,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Packing--inject-63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,300.2v-5.73a.55.55,0,0,1,0-1.1l6.54,0v7.94H256A.55.55,0,0,1,256,300.2Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,300.2v-5.73a.55.55,0,0,1,0-1.1l6.54,0v7.94H256A.55.55,0,0,1,256,300.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.97,
    y: 294.47,
    width: 5.08,
    height: 5.72,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.97,
    y: 294.47,
    width: 5.08,
    height: 5.72,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,300.74h17.61c1.21,0,2.19-1.52,2.19-3.41s-1-3.41-2.19-3.41H260Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,300.74h17.61c1.21,0,2.19-1.52,2.19-3.41s-1-3.41-2.19-3.41H260Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260,293.37c5.77,0,11.54-.1,17.3,0,4,.07,4.16,7.66.29,7.92-2.7.19-5.47,0-8.18,0H260a.55.55,0,0,1,0-1.09h16.39c1.27,0,2.17,0,2.66-1.51.42-1.3.29-3.93-1.44-4.22a3.87,3.87,0,0,0-.59,0H260a.55.55,0,0,1,0-1.1Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,309.4v-7.18a.69.69,0,0,0,0-1.38l-8.19,0v10h8.19A.69.69,0,0,0,281.87,309.4Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,309.4v-7.18a.69.69,0,0,0,0-1.38l-8.19,0v10h8.19A.69.69,0,0,0,281.87,309.4Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.51,
    y: 302.22,
    width: 6.36,
    height: 7.17,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.51,
    y: 302.22,
    width: 6.36,
    height: 7.17,
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,310.08H254.78c-1.52,0-2.75-1.91-2.75-4.27s1.23-4.28,2.75-4.28h22.06Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,310.08H254.78c-1.52,0-2.75-1.91-2.75-4.27s1.23-4.28,2.75-4.28h22.06Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.84,300.84c-7.22,0-14.46-.13-21.68,0-4.95.09-5.22,9.6-.36,9.93,3.38.23,6.86,0,10.25,0h11.79a.69.69,0,0,0,0-1.37H256.3c-1.58,0-2.72,0-3.33-1.9-.53-1.62-.36-4.92,1.81-5.28a4.57,4.57,0,0,1,.74,0h21.32a.69.69,0,0,0,0-1.38Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.84,300.84c-7.22,0-14.46-.13-21.68,0-4.95.09-5.22,9.6-.36,9.93,3.38.23,6.86,0,10.25,0h11.79a.69.69,0,0,0,0-1.37H256.3c-1.58,0-2.72,0-3.33-1.9-.53-1.62-.36-4.92,1.81-5.28a4.57,4.57,0,0,1,.74,0h21.32a.69.69,0,0,0,0-1.38Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 241.44,
    y: 306.82,
    width: 35.63,
    height: 35.7,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.44,
    y: 306.82,
    width: 35.63,
    height: 35.7,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.07,
    y: 306.82,
    width: 21.88,
    height: 35.7,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.07,
    y: 306.82,
    width: 21.88,
    height: 35.7,
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.26 316.86 234.64 316.86 241.44 306.82 277.07 306.82 270.26 316.86",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.26 316.86 234.64 316.86 241.44 306.82 277.07 306.82 270.26 316.86",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.52 316.86 305.4 316.86 298.95 306.82 277.07 306.82 283.52 316.86",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "283.52 316.86 305.4 316.86 298.95 306.82 277.07 306.82 283.52 316.86",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.64,
    y: 342.52,
    width: 59.83,
    height: 59.95,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.64,
    y: 342.52,
    width: 59.83,
    height: 59.95,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.47,
    y: 342.52,
    width: 36.75,
    height: 59.95,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.47,
    y: 342.52,
    width: 36.75,
    height: 59.95,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.17 342.51 294.17 365.2 295.12 364.34 296.8 365.39 298.27 364.34 300.16 365.39 302.15 364.34 303.41 365.39 304.88 364.62 304.88 342.51 294.17 342.51",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.17 342.51 294.17 365.2 295.12 364.34 296.8 365.39 298.27 364.34 300.16 365.39 302.15 364.34 303.41 365.39 304.88 364.62 304.88 342.51 294.17 342.51",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-63"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "183.95 379.64 190.67 400.15 183.18 403.43 173.77 385.47 183.95 379.64",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "179.02 395.49 188.08 392.25 184.85 383.43 175.33 388.44 179.02 395.49",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178,404.51c-1.1.63-2.34,1.06-3,.74a1,1,0,0,1-.48-1,1.35,1.35,0,0,1,.38-.91c1.23-1.27,5.27-1.11,5.45-1.1a.24.24,0,0,1,.23.18.26.26,0,0,1-.06.28A17.47,17.47,0,0,1,178,404.51Zm-2.36-1.1a1.48,1.48,0,0,0-.37.29.66.66,0,0,0-.24.55c0,.38.11.49.21.53.72.41,2.95-.85,4.46-2A10.13,10.13,0,0,0,175.65,403.41Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.52,402.7a.15.15,0,0,1-.09,0c-1.33.09-4.5-.78-4.86-1.94-.11-.27-.09-.67.43-1.05a1.64,1.64,0,0,1,1.32-.28c1.62.34,3.24,2.76,3.32,2.87a.27.27,0,0,1,0,.26A.21.21,0,0,1,180.52,402.7Zm-4.17-2.62-.12.06c-.35.24-.29.41-.27.48.27.66,2.48,1.48,3.94,1.56a6,6,0,0,0-2.7-2.22,1.15,1.15,0,0,0-.85.12Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,400.61c5.4-1.18,7.28-3.34,7.28-3.34l1-.73a9.54,9.54,0,0,1,2.63,2.63,56.12,56.12,0,0,0,5.27,5.69h0c.73.72-.07,1.51-1.28,2.07-.1.05-3.93,2.75-8.56,5.43-5.48,3.16-4.68,3-11.1,6.86-3.88,2.31-6.88-2.68-5.39-3.86,6.76-5.27,7.82-8.58,9.06-13C180.92,401.54,180.86,400.79,181.7,400.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.7,146.47c.58-1.2-.57.15-.59-.49,0,.27.69,1,.83,1.39.74,2,1.45,4,2,6.12,1.87,6.92,3.15,14,4.4,21,2.79,15.72,5,31.55,7.14,47.38q.72,5.52,1.42,11c.23,2,3.33,2,3.09,0q-2.22-18-4.92-36c-1.44-9.7-3-19.39-4.8-29-1.27-6.71-2.43-13.69-4.84-20.1-.95-2.56-4.15-7.64-6.41-2.92-.85,1.79,1.81,3.36,2.67,1.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.24 393.98 113.46 410.12 104.36 409.05 105.6 393.44 116.24 393.98",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100,408.6c-1.18-.14-2.37-.5-2.7-1.06a.85.85,0,0,1,.13-1,1.19,1.19,0,0,1,.78-.44c1.63-.24,4.71,2.05,4.84,2.15a.22.22,0,0,1,.08.25.24.24,0,0,1-.2.16A15.93,15.93,0,0,1,100,408.6Zm-1.29-2a1.55,1.55,0,0,0-.43,0,.62.62,0,0,0-.48.26c-.2.26-.16.4-.11.48.37.67,2.76,1,4.55,1A10.36,10.36,0,0,0,98.69,406.58Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.87,408.68a.1.1,0,0,1-.09,0c-1.07-.64-3.1-3-2.76-4,0-.26.28-.55.91-.53a1.67,1.67,0,0,1,1.2.53c1.09,1.14,1,3.73,1,3.85a.21.21,0,0,1-.12.19A.22.22,0,0,1,102.87,408.68ZM101,404.56l-.13,0c-.41,0-.46.15-.48.2-.14.64,1.16,2.43,2.25,3.27a5.35,5.35,0,0,0-.9-3.06,1.21,1.21,0,0,0-.74-.38Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104,407.48l10.34,1.27a.85.85,0,0,1,.74.75l.84,8.64a1.4,1.4,0,0,1-1.25,1.54h-.29c-3.72-.53-7-1.14-11.66-1.7-5.48-.67-4.17.16-10.62-.54-3.89-.42-4.06-4.92-2.39-4.94,7.65,0,8.71-2.2,12-4.54A3.37,3.37,0,0,1,104,407.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.46 404.31 115.6 397.72 105.31 397.01 104.8 403.43 114.46 404.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,144.34s-12.87-.92-16.93,8.88c-8.33,20.1-8.81,42.11-8.81,42.11L126,197Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,155.22s-3.35,9.75-5.73,34.51h5.73l2.66-27.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.43,218c-28.51,86.49-24.31,125-24.36,125.82l-.92,53.8,14.45,1.27s10.06-48.13,9.11-72.11c-.12-3.08,15.88-45.85,21.13-67.55,0,0,10.18-23.54,5.35-39.83C153.19,219.44,130.59,211.49,128.43,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.82,244.81a195.77,195.77,0,0,0-1.5,49.52c2.25-9,8.59-22.9,10.52-35.06Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.18,231.43s3.93,49,9.78,89.83c2.91,20.29,26.29,68.53,26.29,68.53s1.45-.4,8.71-2.16c8-1.94,4.31-1.1,4.31-1.1s-1.63-7.69-8.35-39.11c-1.88-8.8-7.54-18.54-8.11-26.86-1.3-19.06-2.87-85.52-3.9-90.35S140.78,223.47,137.18,231.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.75 394.17 101.2 400.44 118.57 401.92 119.79 395.71 101.75 394.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.75 394.17 101.2 400.44 118.57 401.92 119.79 395.71 101.75 394.17",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.07 387.96 173.09 393.92 189.41 388.27 188.11 382.07 171.07 387.96",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.07 387.96 173.09 393.92 189.41 388.27 188.11 382.07 171.07 387.96",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.54,221.12l7.05-60.42a14.27,14.27,0,0,0-13.9-16l-19.87-.37a14.27,14.27,0,0,0-14.53,13.87l-1.65,60.48S135,227.09,165.54,221.12Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.32,229.28l1.27-68.58a14.27,14.27,0,0,0-13.9-16l-19.87-.37a14.27,14.27,0,0,0-14.53,13.87l-2.06,68.65S140.72,235.25,171.32,229.28Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.59,160.7a14,14,0,0,0,.1-1.71h-5.35l-3.62,2.44s4.14,14.48,8.46,21.39Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.49,162.45a.93.93,0,1,1-.93-.93A.93.93,0,0,1,145.49,162.45Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,176.21a.94.94,0,1,1-.93-.93A.93.93,0,0,1,144.56,176.21Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.49,162.45a.93.93,0,1,1-.93-.93A.93.93,0,0,1,145.49,162.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.56,176.21a.94.94,0,1,1-.93-.93A.93.93,0,0,1,144.56,176.21Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,103.13s-6.68,2.27-4,7.93S140.69,103.13,140.69,103.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.69,103.13s-6.68,2.27-4,7.93S140.69,103.13,140.69,103.13Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139,144.65c-.17,1.49,0,3.35,1.6,3.95,2.82,1.05,7.92.91,7.92.91a24,24,0,0,0,6.09-3.74,3.4,3.4,0,0,0,.37-1.21c-3.79-3.5-2.89-11.32-1.94-16.66L143,136.77C144,140.74,144.25,143.13,139,144.65Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,131.48l-5.91,5.29a17.22,17.22,0,0,1,.56,2.93c2.28-.36,5.82-2.35,6.27-4.84A7.16,7.16,0,0,0,149,131.48Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.62,119c-2.21,8.63-3,12.32-8.23,15.94-7.93,5.47-18,.86-18.46-8.25-.36-8.2,3.33-21,12.54-22.75A12.15,12.15,0,0,1,159.62,119Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.47,118.89a19.49,19.49,0,0,1-3.42,4,3.18,3.18,0,0,0,2.45,1Z",
    style: {
      fill: "#ff5652"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,127.42a6.14,6.14,0,0,1-1.06-.12.21.21,0,0,1-.18-.24h0a.23.23,0,0,1,.26-.16,5.76,5.76,0,0,0,5-1.32.21.21,0,1,1,.3.29A5.87,5.87,0,0,1,141.84,127.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.3,117.12a.43.43,0,0,1-.47-.18,5,5,0,0,0-3.61-1.79.43.43,0,0,1,0-.85h0a5.81,5.81,0,0,1,4.3,2.19.42.42,0,0,1-.13.57h0A.34.34,0,0,1,149.3,117.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.43,112.78a.46.46,0,0,1-.31-.31.44.44,0,0,1,.3-.53,4.18,4.18,0,0,1,3.85.76.4.4,0,0,1,0,.57l0,0a.42.42,0,0,1-.59,0h0a3.42,3.42,0,0,0-3-.54A.53.53,0,0,1,135.43,112.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,143.74a.65.65,0,0,1,.86.59c0,1.53.8,4.5,6.12,4.5,5.57,0,7.67-3.26,8.33-4.72a.64.64,0,0,1,.92-.28l1.44.88s-.45,5.94-4.89,8.32c-3.65,2-6.68-3-6.68-3S142,155.56,139,152.3s-1.52-8-1.52-8Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,143.74a.65.65,0,0,1,.86.59c0,1.53.8,4.5,6.12,4.5,5.57,0,7.67-3.26,8.33-4.72a.64.64,0,0,1,.92-.28l1.44.88s-.45,5.94-4.89,8.32c-3.65,2-6.68-3-6.68-3S142,155.56,139,152.3s-1.52-8-1.52-8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.48s-2.3-2.74-1.05-8.35-10.89-2.15-13.22-8.4c0,0,2.85,1.58,5.2.84,0,0-11.64-2.06-7.07-11.57,0,0,2.93,3.17,9.72,3.17s13.32,6.16,12.11,11.43C161.72,112.6,164.61,120.68,156,125.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,122.09l-7.85-3.74-21.23-6.44-.16,4.86a2,2,0,0,0,1.4,2l3.53,1.07a2,2,0,0,0,2.25-.85l.86-1.38a2,2,0,0,1,2.25-.85h0a2,2,0,0,1,1.4,2l-.05,1.62a2,2,0,0,0,1.4,2l3.53,1.07a2,2,0,0,0,2.25-.85l1.6-2.57,8,3.12Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.39,122.09l-7.85-3.74-21.23-6.44-.16,4.86a2,2,0,0,0,1.4,2l3.53,1.07a2,2,0,0,0,2.25-.85l.86-1.38a2,2,0,0,1,2.25-.85h0a2,2,0,0,1,1.4,2l-.05,1.62a2,2,0,0,0,1.4,2l3.53,1.07a2,2,0,0,0,2.25-.85l1.6-2.57,8,3.12Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.71,126.21a6.4,6.4,0,0,1-3.87,3c-2.17.55-3.22-1.41-2.58-3.44.6-1.83,2.43-4.32,4.6-4a2.88,2.88,0,0,1,2.33,3.33A3,3,0,0,1,160.71,126.21Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.26,210.72s-1,2.75,5.73,6.48c0,0,17.29-10.24,16.51-27s-13-45.12-35.81-45.45c0,0-1.43,8.68,8.68,21.38,7,8.83,13.28,16.23,13.84,25.18S172.26,210.72,172.26,210.72Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.47,
    y: 225.13,
    width: 23.12,
    height: 39.35,
    rx: 3.95,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,229.08a4,4,0,0,0-7.91,0v31.45a4,4,0,0,0,7.91,0Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,229.08a4,4,0,0,0-7.91,0v31.45a4,4,0,0,0,7.91,0Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,225.13H166.42a4,4,0,0,1,4,4v10a4.1,4.1,0,0,0,4.1,4.1h7a4.11,4.11,0,0,0,4.11-4.1v-10A4,4,0,0,0,181.64,225.13Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.64,225.13H166.42a4,4,0,0,1,4,4v10a4.1,4.1,0,0,0,4.1,4.1h7a4.11,4.11,0,0,0,4.11-4.1v-10A4,4,0,0,0,181.64,225.13Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.48,243.17a2.58,2.58,0,0,1-.39,0v9.58c0,1.28.73,2.32,1.62,2.32s1.61-1,1.61-2.32v-9.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,243.17h-1.14v9.54c0,1.28.72,2.32,1.62,2.32s1.61-1,1.61-2.32V242.59A4.12,4.12,0,0,1,181.48,243.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.74,236h-1.1c-.89,0-1.61,1-1.61,2.32s.72,2.32,1.61,2.32h1.1c.89,0,1.61-1,1.61-2.32S177.63,236,176.74,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.35,238.28c0,1.28-.72,2.32-1.61,2.32s-1.62-1-1.62-2.32.73-2.32,1.62-2.32S178.35,237,178.35,238.28Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.57,236h-1.1c-.89,0-1.61,1-1.61,2.32s.72,2.32,1.61,2.32h1.1c.89,0,1.61-1,1.61-2.32S184.46,236,183.57,236Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.18,238.28c0,1.28-.72,2.32-1.61,2.32s-1.61-1-1.61-2.32.72-2.32,1.61-2.32S185.18,237,185.18,238.28Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168,234.15q-1.48-19.36-2.18-38.8c-.35-9.7-.58-19.43-.34-29.14.17-6.44-.12-14.05,2.43-20.11.77-1.83-2.22-2.63-3-.82-2.42,5.73-2.28,12.9-2.48,19-.34,10-.11,20,.24,30q.71,20,2.22,39.91c.15,2,3.25,2,3.09,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,234.15q-1.48-19.36-2.18-38.8c-.35-9.7-.58-19.43-.34-29.14.17-6.44-.12-14.05,2.43-20.11.77-1.83-2.22-2.63-3-.82-2.42,5.73-2.28,12.9-2.48,19-.34,10-.11,20,.24,30q.71,20,2.22,39.91c.15,2,3.25,2,3.09,0Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,185.63l-.47,0,.51-9.76a8.29,8.29,0,1,0-16.55-.88l-.52,9.76-.48,0a1.74,1.74,0,0,0-1.83,1.65L122,188l21,1.12.08-1.63A1.75,1.75,0,0,0,141.45,185.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.45,185.63l-.47,0,.51-9.76a8.29,8.29,0,1,0-16.55-.88l-.52,9.76-.48,0a1.74,1.74,0,0,0-1.83,1.65L122,188l21,1.12.08-1.63A1.75,1.75,0,0,0,141.45,185.63Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,185.54l-.48,0,.52-9.76a8.29,8.29,0,0,0-16.56-.88l-.52,9.76-.47,0a1.75,1.75,0,0,0-1.84,1.65l-.09,1.63,21,1.12.09-1.63A1.75,1.75,0,0,0,139.77,185.54Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.77,185.54l-.48,0,.52-9.76a8.29,8.29,0,0,0-16.56-.88l-.52,9.76-.47,0a1.75,1.75,0,0,0-1.84,1.65l-.09,1.63,21,1.12.09-1.63A1.75,1.75,0,0,0,139.77,185.54Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.53,
    cy: 175.31,
    r: 6.6,
    transform: "translate(-83.49 132.88) rotate(-41.96)",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.53,
    cy: 175.31,
    r: 6.6,
    transform: "translate(-83.49 132.88) rotate(-41.96)",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.46,175l-3.37-.18.24-4.49a.53.53,0,0,0-1.06-.06l-.27,5a.53.53,0,0,0,.5.56l3.91.21A.54.54,0,0,0,135.46,175Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84,183.71h11.87a2.4,2.4,0,0,1,2.4,2.4v.47a1.57,1.57,0,0,1-1.57,1.57H140a1.57,1.57,0,0,1-1.57-1.57v-.47A2.4,2.4,0,0,1,140.84,183.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.84,183.71h11.87a2.4,2.4,0,0,1,2.4,2.4v.47a1.57,1.57,0,0,1-1.57,1.57H140a1.57,1.57,0,0,1-1.57-1.57v-.47A2.4,2.4,0,0,1,140.84,183.71Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.26,
    cy: 168.59,
    rx: 2.78,
    ry: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 152.26,
    cy: 168.59,
    rx: 2.78,
    ry: 2.07,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.85,
    y: 178.65,
    width: 2.13,
    height: 5.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.85,
    y: 178.65,
    width: 2.13,
    height: 5.47,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.43,
    y: 178.65,
    width: 2.13,
    height: 5.47,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.43,
    y: 178.65,
    width: 2.13,
    height: 5.47,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.34,174.13a.63.63,0,0,0-.87-.39c-1.05.48-3.08,1.34-3.94,1.17-.57-.11-.91-.94-2.09.55a.82.82,0,0,0-.19.48,1.39,1.39,0,0,0,1.39,1.42c.65,0,.92-.6,1.34-1.06.6-.64,2.75-1.13,3.88-1.35a.63.63,0,0,0,.48-.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,175.46c-1.18-1.49-1.51-.66-2.08-.55-.86.17-2.9-.69-3.94-1.17a.64.64,0,0,0-.88.39h0a.64.64,0,0,0,.49.82c1.13.22,3.28.71,3.88,1.35.42.46.69,1.06,1.34,1.06a1.39,1.39,0,0,0,1.39-1.42A.77.77,0,0,0,156.1,175.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.34,174.13a.63.63,0,0,0-.87-.39c-1.05.48-3.08,1.34-3.94,1.17-.57-.11-.91-.94-2.09.55a.82.82,0,0,0-.19.48,1.39,1.39,0,0,0,1.39,1.42c.65,0,.92-.6,1.34-1.06.6-.64,2.75-1.13,3.88-1.35a.63.63,0,0,0,.48-.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.1,175.46c-1.18-1.49-1.51-.66-2.08-.55-.86.17-2.9-.69-3.94-1.17a.64.64,0,0,0-.88.39h0a.64.64,0,0,0,.49.82c1.13.22,3.28.71,3.88,1.35.42.46.69,1.06,1.34,1.06a1.39,1.39,0,0,0,1.39-1.42A.77.77,0,0,0,156.1,175.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,175.9a4.23,4.23,0,1,1-8.43,0c0-2.55,1.88-3.13,4.21-3.13S150.73,173.35,150.73,175.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.73,175.9a4.23,4.23,0,1,1-8.43,0c0-2.55,1.88-3.13,4.21-3.13S150.73,173.35,150.73,175.9Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,184.1c0,.86-3.1.86-3.1,0a1.55,1.55,0,0,1,3.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,184.1c0,.86-3.1.86-3.1,0a1.55,1.55,0,0,1,3.1,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.53,184.1c0,.86-3.1.86-3.1,0a1.55,1.55,0,0,1,3.1,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.53,184.1c0,.86-3.1.86-3.1,0a1.55,1.55,0,0,1,3.1,0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.77,
    cy: 168.59,
    rx: 2.78,
    ry: 2.07,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 140.77,
    cy: 168.59,
    rx: 2.78,
    ry: 2.07,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,167.18c0,4.81-3.16,6.24-7.05,6.24s-7-1.43-7-6.24,3.15-6.24,7-6.24S153.56,162.36,153.56,167.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.56,167.18c0,4.81-3.16,6.24-7.05,6.24s-7-1.43-7-6.24,3.15-6.24,7-6.24S153.56,162.36,153.56,167.18Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 143.68,
    cy: 169.17,
    rx: 0.58,
    ry: 0.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.87,
    cy: 169.17,
    rx: 0.58,
    ry: 0.82,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117,178.07c-.41-5.06-1.57-10.51-4.39-14.78-.13-.21.18-.46.32-.24,2.85,4.33,4,9.85,4.46,15,0,.25-.37.3-.39,0Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117,178.07c-.41-5.06-1.57-10.51-4.39-14.78-.13-.21.18-.46.32-.24,2.85,4.33,4,9.85,4.46,15,0,.25-.37.3-.39,0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,176.93s-1.36-15.24,6.36-15.21c8.16,0-4,6.8-5.61,15.11Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.55,176.93s-1.36-15.24,6.36-15.21c8.16,0-4,6.8-5.61,15.11Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,171.56a.14.14,0,0,1,0-.15l.06-.08c.15-.45.31-.9.48-1.34a2.66,2.66,0,0,1-.86-1.65c0-.24.36-.3.38-.05a2.22,2.22,0,0,0,.63,1.31c.26-.62.54-1.24.85-1.84a3.33,3.33,0,0,1-1-2.14c0-.24.37-.3.37-.05a3,3,0,0,0,.78,1.82c.31-.59.66-1.16,1-1.72a5.3,5.3,0,0,1-.82-2.18.19.19,0,0,1,.38-.05,5,5,0,0,0,.67,1.86,21.14,21.14,0,0,1,2.68-3.2c.18-.17.41.13.24.3a19.43,19.43,0,0,0-1.55,1.71,11.61,11.61,0,0,1,2.64-.8c.24-.05.29.33,0,.38a8.19,8.19,0,0,0-3.24,1.19h0c-.2.27-.4.54-.59.82a.2.2,0,0,1-.11.18l-.23.37a5,5,0,0,1,2.44-.18.19.19,0,0,1-.05.37,4.35,4.35,0,0,0-2.73.37h0c-.18.31-.35.61-.51.92a.18.18,0,0,1-.07.15c-.09.17-.18.34-.26.52a3.13,3.13,0,0,1,1.77,0c.23.07.18.44-.05.38-.6-.15-1.53-.32-2,.22h0c-.27.59-.5,1.19-.71,1.8a3.59,3.59,0,0,1,1.15-.4c.24-.05.29.32,0,.37a2.27,2.27,0,0,0-1.4.68,21.75,21.75,0,0,0-1,5.43c0,.24-.39.19-.38-.06A21.52,21.52,0,0,1,118.74,171.56Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.74,171.56a.14.14,0,0,1,0-.15l.06-.08c.15-.45.31-.9.48-1.34a2.66,2.66,0,0,1-.86-1.65c0-.24.36-.3.38-.05a2.22,2.22,0,0,0,.63,1.31c.26-.62.54-1.24.85-1.84a3.33,3.33,0,0,1-1-2.14c0-.24.37-.3.37-.05a3,3,0,0,0,.78,1.82c.31-.59.66-1.16,1-1.72a5.3,5.3,0,0,1-.82-2.18.19.19,0,0,1,.38-.05,5,5,0,0,0,.67,1.86,21.14,21.14,0,0,1,2.68-3.2c.18-.17.41.13.24.3a19.43,19.43,0,0,0-1.55,1.71,11.61,11.61,0,0,1,2.64-.8c.24-.05.29.33,0,.38a8.19,8.19,0,0,0-3.24,1.19h0c-.2.27-.4.54-.59.82a.2.2,0,0,1-.11.18l-.23.37a5,5,0,0,1,2.44-.18.19.19,0,0,1-.05.37,4.35,4.35,0,0,0-2.73.37h0c-.18.31-.35.61-.51.92a.18.18,0,0,1-.07.15c-.09.17-.18.34-.26.52a3.13,3.13,0,0,1,1.77,0c.23.07.18.44-.05.38-.6-.15-1.53-.32-2,.22h0c-.27.59-.5,1.19-.71,1.8a3.59,3.59,0,0,1,1.15-.4c.24-.05.29.32,0,.37a2.27,2.27,0,0,0-1.4.68,21.75,21.75,0,0,0-1,5.43c0,.24-.39.19-.38-.06A21.52,21.52,0,0,1,118.74,171.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,177.12S114,164,107.54,165.79c-6.84,1.9,4.9,4.8,8.18,11.41Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.38,177.12S114,164,107.54,165.79c-6.84,1.9,4.9,4.8,8.18,11.41Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.15,172.87a.14.14,0,0,0,0-.13l-.07,0c-.22-.35-.46-.69-.71-1a2.35,2.35,0,0,0,.35-1.59c-.05-.2-.38-.16-.33,0a2,2,0,0,1-.23,1.25q-.54-.7-1.14-1.35a2.92,2.92,0,0,0,.32-2c0-.21-.38-.17-.33,0a2.61,2.61,0,0,1-.23,1.71,16,16,0,0,0-1.26-1.21,4.48,4.48,0,0,0,.19-2c0-.21-.35-.17-.33,0a4.55,4.55,0,0,1-.13,1.72,18.59,18.59,0,0,0-3-2.08c-.19-.1-.31.21-.13.31a17.86,17.86,0,0,1,1.69,1.08,10.2,10.2,0,0,0-2.4-.07c-.21,0-.17.35.05.33a7.37,7.37,0,0,1,3,.26h0c.23.18.46.36.68.56a.17.17,0,0,0,.14.12c.09.08.18.18.28.26a4.44,4.44,0,0,0-2.1.41.16.16,0,0,0,.13.3,3.77,3.77,0,0,1,2.38-.32h0l.64.66a.13.13,0,0,0,.09.1l.34.38a2.77,2.77,0,0,0-1.49.42c-.18.11,0,.41.13.31.47-.27,1.22-.62,1.74-.28h0c.36.43.69.88,1,1.34a3.2,3.2,0,0,0-1.06-.07c-.21,0-.17.34,0,.33a2,2,0,0,1,1.34.24,18.78,18.78,0,0,1,2.09,4.33c.06.2.37.07.3-.13A19.3,19.3,0,0,0,114.15,172.87Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.15,172.87a.14.14,0,0,0,0-.13l-.07,0c-.22-.35-.46-.69-.71-1a2.35,2.35,0,0,0,.35-1.59c-.05-.2-.38-.16-.33,0a2,2,0,0,1-.23,1.25q-.54-.7-1.14-1.35a2.92,2.92,0,0,0,.32-2c0-.21-.38-.17-.33,0a2.61,2.61,0,0,1-.23,1.71,16,16,0,0,0-1.26-1.21,4.48,4.48,0,0,0,.19-2c0-.21-.35-.17-.33,0a4.55,4.55,0,0,1-.13,1.72,18.59,18.59,0,0,0-3-2.08c-.19-.1-.31.21-.13.31a17.86,17.86,0,0,1,1.69,1.08,10.2,10.2,0,0,0-2.4-.07c-.21,0-.17.35.05.33a7.37,7.37,0,0,1,3,.26h0c.23.18.46.36.68.56a.17.17,0,0,0,.14.12c.09.08.18.18.28.26a4.44,4.44,0,0,0-2.1.41.16.16,0,0,0,.13.3,3.77,3.77,0,0,1,2.38-.32h0l.64.66a.13.13,0,0,0,.09.1l.34.38a2.77,2.77,0,0,0-1.49.42c-.18.11,0,.41.13.31.47-.27,1.22-.62,1.74-.28h0c.36.43.69.88,1,1.34a3.2,3.2,0,0,0-1.06-.07c-.21,0-.17.34,0,.33a2,2,0,0,1,1.34.24,18.78,18.78,0,0,1,2.09,4.33c.06.2.37.07.3-.13A19.3,19.3,0,0,0,114.15,172.87Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.19,190.56l7.14-1a2.12,2.12,0,0,0,1.84-2.18l-.39-10.32a1.35,1.35,0,0,0-1.53-1.29l-10.61,1.42a1.36,1.36,0,0,0-1.14,1.65l2.35,10.06A2.12,2.12,0,0,0,115.19,190.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.19,190.56l7.14-1a2.12,2.12,0,0,0,1.84-2.18l-.39-10.32a1.35,1.35,0,0,0-1.53-1.29l-10.61,1.42a1.36,1.36,0,0,0-1.14,1.65l2.35,10.06A2.12,2.12,0,0,0,115.19,190.56Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.72,163.63c.5-.6,3.28-.85,1.89-2.9s-2.52-3.3-2.26-3.88a2.05,2.05,0,0,0-1.22,2.58s-1.34-.86-2.27-.44a4.43,4.43,0,0,0,.27,2s-1.73-.95-2.56.06a10.2,10.2,0,0,1,3,3C110.42,165.68,111.85,164.67,112.72,163.63Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.72,163.63c.5-.6,3.28-.85,1.89-2.9s-2.52-3.3-2.26-3.88a2.05,2.05,0,0,0-1.22,2.58s-1.34-.86-2.27-.44a4.43,4.43,0,0,0,.27,2s-1.73-.95-2.56.06a10.2,10.2,0,0,1,3,3C110.42,165.68,111.85,164.67,112.72,163.63Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.98,
    y: 187.63,
    width: 35.63,
    height: 35.63,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.98,
    y: 187.63,
    width: 35.63,
    height: 35.63,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.61,
    y: 187.63,
    width: 21.88,
    height: 35.63,
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146.61,
    y: 187.63,
    width: 21.88,
    height: 35.63,
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.8 197.65 104.17 197.65 110.98 187.63 146.61 187.63 139.8 197.65",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.8 197.65 104.17 197.65 110.98 187.63 146.61 187.63 139.8 197.65",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.05 197.65 174.94 197.65 168.49 187.63 146.61 187.63 153.05 197.65",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "153.05 197.65 174.94 197.65 168.49 187.63 146.61 187.63 153.05 197.65",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.11,209.31l.64-.26a3.58,3.58,0,0,1,4.59,1.77l.15.3a3.59,3.59,0,0,1,.28,2.28l-1.18,5.77a3.6,3.6,0,0,1-2.2,2.63h0a2.21,2.21,0,0,1-3-1.89l-.64-8.39A2.2,2.2,0,0,1,109.11,209.31Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.68,211.12,170,214.77l-1.09-.57a1.56,1.56,0,0,0-2.15.74,15.15,15.15,0,0,1-7.54,7.32,1.55,1.55,0,0,0,0,2.83,9.84,9.84,0,0,0,2.65.74c3.36.42,5,2.09,7.56,0s4.06-6.72,4.06-6.72l4.53-3.3Z",
    style: {
      fill: "#ff8b7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,211a12.15,12.15,0,0,0,7,7L181,216.5s-5.44-3.49-8-8.12Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.13,211a12.15,12.15,0,0,0,7,7L181,216.5s-5.44-3.49-8-8.12Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,136.69,158.91,143l-1.82-4.46a1.46,1.46,0,0,1,.32-1.58l1.73-1.73a1.45,1.45,0,0,1,1.58-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.18,136.69,158.91,143l-1.82-4.46a1.46,1.46,0,0,1,.32-1.58l1.73-1.73a1.45,1.45,0,0,1,1.58-.32Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,147.59H157a1.31,1.31,0,0,1,1.31,1.31V186a0,0,0,0,1,0,0h-2.92a0,0,0,0,1,0,0V148.89A1.31,1.31,0,0,1,156.74,147.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,147.59H157a1.31,1.31,0,0,1,1.31,1.31V186a0,0,0,0,1,0,0h-2.92a0,0,0,0,1,0,0V148.89A1.31,1.31,0,0,1,156.74,147.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,187.64h20.68a3,3,0,0,0-3-3H149.6A3,3,0,0,0,146.55,187.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.55,187.64h20.68a3,3,0,0,0-3-3H149.6A3,3,0,0,0,146.55,187.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,145.2h5.6a0,0,0,0,1,0,0v3.54a0,0,0,0,1,0,0h-5.6a1.58,1.58,0,0,1-1.58-1.58v-.38A1.58,1.58,0,0,1,156.35,145.2Z",
    transform: "translate(-57.55 155.02) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35,145.2h5.6a0,0,0,0,1,0,0v3.54a0,0,0,0,1,0,0h-5.6a1.58,1.58,0,0,1-1.58-1.58v-.38A1.58,1.58,0,0,1,156.35,145.2Z",
    transform: "translate(-57.55 155.02) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,148.18a.81.81,0,1,1-.81-.81A.8.8,0,0,1,158,148.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,148.18a.81.81,0,1,1-.81-.81A.8.8,0,0,1,158,148.18Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79,136.19H168a1.31,1.31,0,0,1,1.31,1.31v10.61a0,0,0,0,1,0,0h-9.79a0,0,0,0,1,0,0V137.5a1.31,1.31,0,0,1,1.31-1.31Z",
    transform: "translate(-52.37 157.87) rotate(-45)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.79,136.19H168a1.31,1.31,0,0,1,1.31,1.31v10.61a0,0,0,0,1,0,0h-9.79a0,0,0,0,1,0,0V137.5a1.31,1.31,0,0,1,1.31-1.31Z",
    transform: "translate(-52.37 157.87) rotate(-45)",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,146.57,168.79,159a2,2,0,0,1-3.32-.87l-2.6-9.3a1.06,1.06,0,0,1,.27-1l6.9-6.9a1.06,1.06,0,0,1,1-.27l9.31,2.6A2,2,0,0,1,181.25,146.57Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.25,146.57,168.79,159a2,2,0,0,1-3.32-.87l-2.6-9.3a1.06,1.06,0,0,1,.27-1l6.9-6.9a1.06,1.06,0,0,1,1-.27l9.31,2.6A2,2,0,0,1,181.25,146.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.79,146.69a.63.63,0,0,0-.88,0,.62.62,0,0,0,0,.87l3.28,3.28a.62.62,0,0,0,.88-.87Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.91,149.56a.51.51,0,0,0-.8-.07.77.77,0,0,0-.07.95l2.76,3.8a.52.52,0,0,0,.81.07.77.77,0,0,0,.07-.95C169.56,153.21,167,149.72,166.91,149.56Z",
    style: {
      fill: "#4079FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.78,144.69a.5.5,0,0,1-.06-.8.73.73,0,0,1,.94-.07l3.8,2.76a.51.51,0,0,1,.07.8.75.75,0,0,1-.95.07Z",
    style: {
      fill: "#4079FF"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuittingajobRafiki);
export default __webpack_public_path__ + "static/media/Quitting a job-rafiki.d11c494e55f6d723af053c04a60a4187.svg";
export { ForwardRef as ReactComponent };